import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import "./index.css";
import "./home.css";
import LoginChoice from "./pages/LoginChoice";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import ContactUs from "./pages/ContactUs";
import TermsAndConditions from "./pages/TermsAndConditions";
import DeleteAccount from "./pages/DeleteAccount";

const DoctorApp = lazy(() => import("./doctor/DoctorApp"));
const PatientApp = lazy(() => import("./patient/PatientApp"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    if (pathname !== "/")
      document.title = `${{ "/contact": "Contact us", "/privacy-policy": "Privacy policy", "/refund-policy": "Refund policy", "/terms": "Terms and conditions", "/delete": "Delete account", "/delete-account": "Delete account" }[pathname] || "NephroCore Nexus"} | NephroCore Nexus`;
  }, [pathname]);
  return null;
}

function Layout() {
  const { pathname } = useLocation();
  if (pathname === "/doctor" || pathname.startsWith("/doctor/")) return <Suspense fallback={<div role="status" className="pw-loading">Opening your doctor portal…</div>}><Routes><Route path="/doctor/*" element={<DoctorApp />} /></Routes></Suspense>;
  if (pathname === "/patient" || pathname.startsWith("/patient/"))
    return (
      <Suspense
        fallback={
          <div role="status" style={{ padding: 60 }}>
            Opening your care workspace…
          </div>
        }
      >
        <Routes>
          <Route path="/patient/*" element={<PatientApp />} />
        </Routes>
      </Suspense>
    );
  return (
    <div className="nc-site-shell">
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginChoice />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/delete" element={<DeleteAccount />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
